import PolicyCard from './PolicyCard'
import {NavLink} from 'react-router-dom'

interface DonationRow {
  Sequence: number
  DonationDate: string
  DonationAmount: string
  CheckNumber?: string
  DonationType: string
}

interface DonationPreviewCardProps {
  donations: DonationRow[]
}

export function DonationPreviewCard({donations}: DonationPreviewCardProps) {
  if (!donations?.length) return null

  const firstThree = donations.slice(0, 3)

  return (
    <PolicyCard title='Senior Living Foundation Recent Donations' cardClassname='bg-white primary-border' titleClassname='text-black pb-3'>
      <ul className='list-disc pl-5 flex flex-col gap-2'>
        {firstThree.map((d) => (
          <li key={d.Sequence} className='text-gray-900'>
            Donation of <span className='font-medium'>{d.DonationAmount}</span> made on <span className='font-medium'>{d.DonationDate}</span> of type{' '}
            <span className='font-medium'>{d.DonationType}</span>
            {d.CheckNumber && <> (Check #{d.CheckNumber})</>}
          </li>
        ))}
      </ul>

      <div className='pt-2'>
        <NavLink to='/seniorlivingfoundation' className='text-primary text-sm font-medium hover:underline'>
          View all donations →
        </NavLink>{' '}
      </div>
    </PolicyCard>
  )
}
export default DonationPreviewCard
